$(function () {
  let section = $('#anfitrion-plan-checkout')
  if (section.get(0) == null) {
    return
  }

  var stripeHelper = null;

  let vueApp = new Vue({
    el: section.get(0),
    data: {
      plan: planJson,
      isMiPlan: isMiPlan,
      isPlanRenovar: isPlanRenovar,
      isCambiarTarjeta: false
    },
    mounted() {
      vueApp = this
      if(!this.isMiPlan){
        this.initStripe()
      }
    },
    methods: {
      initStripe(){
        stripeHelper = new StripeHelper(stripePublic)
        stripeHelper.initForm("#card-number-element",
          "#card-expiry-element", "#card-cvc-element",
          "#cardholder-name")
        this.validar()
      },
      cancelarCambioTarjeta(){
        this.isCambiarTarjeta = false
        if(stripeHelper != null){
          stripeHelper.clear()
          stripeHelper = null
        }
      },
      cambiarTarjeta(){
        this.isCambiarTarjeta = true
        this.initStripe()
      },
      validar(){
        if($('#payment-form')[0] == null){
          setTimeout(()=>{
            vueApp.validar()
          }, 100)
          return
        }
        $('#payment-form').validarForm((form) => {
          vueApp.pagarPlan()
        })
      },
      async pagarPlan(){
        $("#btnPagar").loader("show")
        let paymentId = await stripeHelper.tokenizar()
        if(paymentId == null){
          $("#btnPagar").loader("hide")
          return
        }

        axios
          .post('/planes/' + this.plan.hash, {
            actualizar_tarjeta: this.isCambiarTarjeta,
            payment_method_id: paymentId
        })
          .then((respuesta) => {
            $("#btnPagar").loader("hide")
            if (respuesta.data.error) {
              Alert(respuesta.data.error, "info")
              return
            }
            Alert(!vueApp.isCambiarTarjeta ? "¡Gracias por suscribirte!" : "¡Tarjeta actualizada!", "success")
              .finally(() => {
                location.href = respuesta.data.redirect
              })
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            $("#btnPagar").loader("hide")
            Alert("Ocurrió un error inesperado", "info")
          })
      },
      cancelarPlan(){
        AlertConfirm("¿Cancelar suscripción?", "warning").then(ok => {
          if(ok){
            axios
              .post('/planes/cancelar')
              .then((respuesta) => {
                if (respuesta.data.error) {
                  Alert(respuesta.data.error, "info")
                  return
                }
                Alert("¡Suscripción cancelada!", "success")
                  .finally(() => {
                    location.reload()
                  })
              })
              .catch((error) => {
                ReportErrorLog(error)
                console.error(error)
                Alert("Ocurrió un error inesperado", "info")
              })
          }
        })
      }
    }
  });
});
